import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { useLocalizedPath } from "../hooks/useLocale";

type GuardProps = {
  children: React.ReactNode;
};

const AuthGuard = ({ children }: GuardProps) => {
  const { user, removeAuth } = useAuth();
  const location = useLocation();
  const localizedPath = useLocalizedPath();

  useEffect(() => {
    if (!user) {
      removeAuth(location.pathname);
    }
  }, [user, removeAuth, location.pathname]);

  if (user) {
    if (user.active) {
      return children;
    }
    return <Navigate to={localizedPath("/auth/activate-account")} />;
  }

  return null;
};

export default AuthGuard;
